import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_NAT_CONFIGURATION = '/natconfigs';

export const SET_NAT_CONFIGURATION_LOADING = 'SET_NAT_CONFIGURATION_LOADING';
export const GO_TO_NAT_CONFIGURATION_CREATE = 'GO_TO_NAT_CONFIGURATION_CREATE';
export const GO_TO_NAT_CONFIGURATION_VIEW = 'GO_TO_NAT_CONFIGURATION_VIEW';
export const GO_TO_NAT_CONFIGURATION_EDIT = 'GO_TO_NAT_CONFIGURATION_EDIT';
export const GO_TO_NAT_CONFIGURATION_COPY = 'GO_TO_NAT_CONFIGURATION_COPY';
export const GO_TO_NAT_CONFIGURATION_LIST = 'GO_TO_NAT_CONFIGURATION_LIST';
export const GET_NAT_CONFIGURATION_LIST = 'GET_NAT_CONFIGURATION_LIST';
export const GET_NAT_CONFIGURATION_LIST_PENDING = 'GET_NAT_CONFIGURATION_LIST_PENDING';
export const GET_NAT_CONFIGURATION_LIST_FULFILLED = 'GET_NAT_CONFIGURATION_LIST_FULFILLED';
export const GET_NAT_CONFIGURATION = 'GET_NAT_CONFIGURATION';
export const GET_NAT_CONFIGURATION_PENDING = 'GET_NAT_CONFIGURATION_PENDING';
export const GET_NAT_CONFIGURATION_FULFILLED = 'GET_NAT_CONFIGURATION_FULFILLED';
export const CREATE_NAT_CONFIGURATION = 'CREATE_NAT_CONFIGURATION';
export const CREATE_NAT_CONFIGURATION_PENDING = 'CREATE_NAT_CONFIGURATION_PENDING';
export const CREATE_NAT_CONFIGURATION_FULFILLED = 'CREATE_NAT_CONFIGURATION_FULFILLED';
export const CREATE_NAT_CONFIGURATION_REJECTED = 'CREATE_NAT_CONFIGURATION_REJECTED';
export const UPDATE_NAT_CONFIGURATION = 'UPDATE_NAT_CONFIGURATION';
export const UPDATE_NAT_CONFIGURATION_FULFILLED = 'UPDATE_NAT_CONFIGURATION_FULFILLED';
export const UPDATE_NAT_CONFIGURATION_REJECTED = 'UPDATE_NAT_CONFIGURATION_REJECTED';
export const DELETE_NAT_CONFIGURATION = 'DELETE_NAT_CONFIGURATION';
export const DELETE_NAT_CONFIGURATION_FULFILLED = 'DELETE_NAT_CONFIGURATION_FULFILLED';
export const DELETE_NAT_CONFIGURATION_REJECTED = 'DELETE_NAT_CONFIGURATION_REJECTED';
export const SELECT_NAT_CONFIGURATION = 'SELECT_NAT_CONFIGURATION';

export enum NatConfigurationPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface NatConfiguration {
  id?: string
  privateIp: string,
  privatePort: string,
  publicIp: string,
  publicPort: string
}

export interface NatConfigurationState {
  entities: NatConfiguration[]
  selected: NatConfiguration[],
  single: NatConfiguration | null
  createdId: string | null
  ui: NatConfigurationsUIState
}

export interface NatConfigurationsUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToNatConfigurationListAction extends AnyAction {
  type: typeof GO_TO_NAT_CONFIGURATION_LIST
}

export interface SetNatConfigurationLoadingAction extends AnyAction {
  type: typeof SET_NAT_CONFIGURATION_LOADING
  payload: { isLoading: boolean }
}

export interface GetNatConfigurationListAction extends AnyAction {
  type: typeof GET_NAT_CONFIGURATION_LIST
  payload: AxiosPromise<ServerResponse<NatConfiguration>>
}

export interface GetNatConfigurationListPendingAction extends AnyAction {
  type: typeof GET_NAT_CONFIGURATION_LIST_PENDING
  payload: null
}

export interface GetNatConfigurationListFulfilledAction extends AnyAction {
  type: typeof GET_NAT_CONFIGURATION_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<NatConfiguration>>
}

export interface GetNatConfigurationAction extends AnyAction {
  type: typeof GET_NAT_CONFIGURATION
  payload: AxiosPromise<ServerResponse<NatConfiguration>>
}

export interface GetNatConfigurationPendingAction extends AnyAction {
  type: typeof GET_NAT_CONFIGURATION_PENDING
  payload: null
}

export interface GetNatConfigurationFulfilledAction extends AnyAction {
  type: typeof GET_NAT_CONFIGURATION_FULFILLED
  payload: AxiosResponse<ServerResponse<NatConfiguration>>
}

export interface CreateNatConfigurationThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateNatConfigurationAction extends AnyAction {
  type: typeof CREATE_NAT_CONFIGURATION
  payload: AxiosPromise<ServerResponse<NatConfiguration>>
}

export interface CreateNatConfigurationPendingAction extends AnyAction {
  type: typeof CREATE_NAT_CONFIGURATION_PENDING
  payload: null
}

export interface CreateNatConfigurationFulfilledAction extends AnyAction {
  type: typeof CREATE_NAT_CONFIGURATION_FULFILLED
  payload: AxiosResponse<ServerResponse<NatConfiguration>>
}

export interface CreateNatConfigurationRejectedAction extends AnyAction {
  type: typeof CREATE_NAT_CONFIGURATION_REJECTED
  payload: AxiosResponse<ServerResponse<NatConfiguration>>
}

export interface UpdateNatConfigurationThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateNatConfigurationAction extends AnyAction {
  type: typeof UPDATE_NAT_CONFIGURATION
  payload: AxiosPromise<ServerResponse<NatConfiguration>>
}

export interface DeleteNatConfigurationThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteNatConfigurationAction extends AnyAction {
  type: typeof DELETE_NAT_CONFIGURATION
  payload: AxiosPromise<ServerResponse<NatConfiguration>>
}

export interface DeleteNatConfigurationFulfilledAction extends AnyAction {
  type: typeof DELETE_NAT_CONFIGURATION_FULFILLED
  payload: AxiosResponse<ServerResponse<NatConfiguration>>
}

export interface DeleteNatConfigurationRejectedAction extends AnyAction {
  type: typeof DELETE_NAT_CONFIGURATION_REJECTED
  payload: AxiosResponse<ServerResponse<NatConfiguration>>
}

export interface SelectNatConfigurationAction extends AnyAction{
  type: typeof SELECT_NAT_CONFIGURATION
  payload: NatConfiguration[]
}

export type NatConfigurationActionTypes =
  GoToNatConfigurationListAction |
  SetNatConfigurationLoadingAction |
  GetNatConfigurationListAction |
  GetNatConfigurationListPendingAction |
  GetNatConfigurationListFulfilledAction |
  GetNatConfigurationAction |
  GetNatConfigurationPendingAction |
  GetNatConfigurationFulfilledAction |
  CreateNatConfigurationAction |
  CreateNatConfigurationPendingAction |
  CreateNatConfigurationFulfilledAction |
  CreateNatConfigurationRejectedAction |
  DeleteNatConfigurationAction |
  DeleteNatConfigurationFulfilledAction |
  DeleteNatConfigurationRejectedAction |
  SelectNatConfigurationAction;
